import { IntegrationTokenName } from '../domains/api';
import type { Integration } from '../types';

export const optimizely: Integration = {
  slug: 'optimizely',
  icon: 'optimizely',
  name: 'integrations:optimizely.title',
  tokenName: IntegrationTokenName.Optimizely,
  provider: 'integrations:card.hotjar-optimizely',
  actionLabel: {
    autoTrackRecordings: 'integrations:details.header.optimizely-auto-track-recordings',
  },
  description: 'integrations:optimizely.description-revamp',
  descriptionLarge: null,
  resources: [
    {
      copy: 'integrations:optimizely.using-with-hotjar',
      url: '/articles/115009347067-Using-Hotjar-With-Optimizely',
      icon: 'page_full',
    },
    {
      copy: 'integrations:optimizely.key-benefits',
      url: 'https://www.hotjar.com/integrations/optimizely/',
      icon: 'page_full',
    },
  ],
  images: null,
  videoUrl: null,
  gate: 'core.integrations',
  isEnabled: false,
  settings: null,
};
